// import React from 'react'
// import Modal from 'react-modal';

// function NewsModal(props) {
//     const customStyles = {
//         content: {
//             top: '50%',
//             left: '50%',
//             right: 'auto',
//             bottom: 'auto',
//             marginRight: '-50%',
//             transform: 'translate(-50%, -50%)',
//             width: "500px",
//             maxHeight: "500px",
//             backgroundColor: "white",
//             padding: "2%",
//         },
//         overlay: {
//             backgroundColor: 'rgba(0, 0, 0, 0.75)',
//             zIndex: "1000002 !important",
//         }
//     };
//     return (
//         <div className='modal-div'>
//             <Modal
//                 onAfterClose={() => {
//                     if (props.setModalOpen) {
//                         props.setModalOpen(false)
//                         props.setIsOpen(false);
//                         // props.setModalId("")
//                     }
//                 }}
//                 isOpen={props.modalIsOpen}
//                 onAfterOpen={props.afterOpenModal}
//                 onRequestClose={props.closeModal}
//                 style={customStyles}
//                 contentLabel="Example Modal"
//             >
//                 {props.children}
//             </Modal>
//         </div>

//     )
// }

// export default NewsModal




import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './NewsModal.css';

const NEWS_OVERLAY_Z = 1000002; // higher than CIPBITS (99999)

function NewsModal(props) {
  const {
    modalIsOpen,
    afterOpenModal,
    closeModal,
    setModalOpen, // optional
    setIsOpen,    // optional
    contentLabel,
    children
  } = props;

  const portalRootRef = useRef(null);
  const createdRef = useRef(false);

  // Ensure portal root exists
  useEffect(() => {
    let el = document.getElementById('news-modal-root');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('id', 'news-modal-root');
      document.body.appendChild(el);
      createdRef.current = true;
    }
    portalRootRef.current = el;

    return () => {
      // If we created it, we can clean it up (optional)
      if (createdRef.current && el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    };
  }, []);

  // Handle after open and after close side-effects
  useEffect(() => {
    if (!modalIsOpen) return;

    // afterOpen
    if (afterOpenModal) afterOpenModal();

    // lock body scroll while open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (closeModal) closeModal(e);
      }
    };
    document.addEventListener('keydown', onKeyDown);

    // afterClose (mimics react-modal's onAfterClose block in your code)
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKeyDown);

      if (setModalOpen) {
        setModalOpen(false);
        if (setIsOpen) setIsOpen(false);
      }
    };
  }, [modalIsOpen, afterOpenModal, closeModal, setModalOpen, setIsOpen]);

  if (!modalIsOpen || !portalRootRef.current) return <div className="modal-div" />;

  const contentInlineStyle = {
    width: '500px',
    maxHeight: '500px',
    backgroundColor: 'white',
    padding: '2%',
  };

  const modalNode = (
    <div
      className="news-modal-overlay"
      style={{ zIndex: NEWS_OVERLAY_Z }}
      role="dialog"
      aria-modal="true"
      aria-label={contentLabel || 'Example Modal'}
      onClick={closeModal}
    >
      <div
        className="news-modal-content"
        style={contentInlineStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  // Keep wrapper div to avoid changing structure
  return (
    <div className="modal-div">
      {ReactDOM.createPortal(modalNode, portalRootRef.current)}
    </div>
  );
}

export default NewsModal;